import 'regenerator-runtime/runtime';
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { hydrate } from 'react-dom';
import { datalayerInstance } from './app/datalayer';
import loadPolyfills from '@mfe/browse-polyfill-loader';

const errorLogger = console.error;
const cache = createCache({key: "category-page"})

function render(App) {
  hydrate(
    <CacheProvider value={cache}>
      <App
        // eslint-disable-next-line no-underscore-dangle
        {...window.__CATEGORY_PAGE_STATE__}
        highPriorityEvents={window.gap.highPriorityEvents}
        criticalCss={[]}
        criticalResources={[]}
        datalayer={datalayerInstance()}
        errorLogger={errorLogger}
      />
    </CacheProvider>,
    document.getElementById('category-page')
  );
}

// eslint-disable-next-line no-underscore-dangle
loadPolyfills(window.__CATEGORY_PAGE_POLYFILL__.promisePolyfillPath)(() => {
  /* eslint @typescript-eslint/no-var-requires: "off" */
  const App = require('./app').App;
  render(App);
});
